import { FrameWorkChange, FrameWorkGetDefaulValue, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkMessageSuccessAlert, FrameWorkPutTextToActiveInactiveUser, FrameWorkPutValueIfEditByDefault, FrameWorkSimpleMessageState, FrameWorkVerifyDataIsCompleted } from 'orden_express/frameWork/frameWork.js';
import { setDataRouteForEdit, setMessageSaveStateRoute } from 'orden_express/routes/routesActions.js';
import { requestSaveRoute } from 'orden_express/routes/routesEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, FormGroup, Input, Label } from 'reactstrap';
import { bindActionCreators } from 'redux';

class RoutesForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      idState: '',
      nameState: '',
      informationState: '',
      activeState: '',
      id: '',
      name: '',
      information: '',
      active: '',
    };
    this.props.setDataRouteForEdit(null);
  }

  componentDidMount() {
    this.props.setMessageSaveStateRoute(0);
    this.props.setDataRouteForEdit(null);
    this.updateValueStateForm();
  }

  updateValueStateForm = () => {
    let localRouteEdit = this.props.routesReducerState.dataRouteForEdit || null;
    FrameWorkPutValueIfEditByDefault(this, 'id', localRouteEdit, 'id', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'name', localRouteEdit, 'name', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'information', localRouteEdit, 'information', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'active', localRouteEdit, 'active', 'have-content', 1);
    if (localRouteEdit == null || localRouteEdit === undefined) {
      this.setState({ active: 1 });
    }
  }

  componentWillUpdate(prevProps) {
    if (this.props.routesReducerState.dataRouteForEdit !== prevProps.routesReducerState.dataRouteForEdit) {
      this.updateValueStateForm();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.routesReducerState.messageSaveStateRoute !== prevProps.routesReducerState.messageSaveStateRoute) {
      this.processMessageState(this.props.routesReducerState.messageSaveStateRoute);
    }
    if (this.props.routesReducerState.dataRouteForEdit !== prevProps.routesReducerState.dataRouteForEdit) {
      this.updateValueStateForm();
    }
  }

  /**
   * Recupera los datos para almacenar la información de la ruta
   */
  getDataFromForm = () => {
    const localRoute = {
      id: this.state.id,
      name: this.state.name,
      information: this.state.information,
      active: 1,
    };
    localRoute.active = 0;
    if (this.state.active) {
      localRoute.active = 1;
    }
    return localRoute;
  }

  /**
   * Valida los campos obligatorios y ayuda a determinar
   * en ellos con un color o etiqueta visual para que el 
   * usuario los identifique
   */
  verifyData = () => {
    var dataIsCompleted = true;
    const listValidation = [
      'nameState',
    ];
    var pos=0;
    var length=listValidation.length;
    while(pos<length){
      var item=listValidation[pos];
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
      pos++;
    }
    /*listValidation.map((item, index) => {
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
    });*/
    if (!dataIsCompleted) {
      FrameWorkMessageErrorAlert(this, 'Faltan datos', 'Debe ingresar todos los datos solicitados')
      return;
    }
    //Al llear a este punto es que todos los datos han sido ingresados y se procede a su registro
    this.props.requestSaveRoute(this.getDataFromForm());
    this.props.setMessageSaveStateRoute(1);
  };

  /**
   * Controla la secuencia de estados para visualizar 
   * los mensajes en el proceso de almacenamiento de un producto
   */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Grabando', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.props.history.goBack, this.props.history.goBack);
        break;
      case 3:
        var localMessageError = this.props.routesReducerState.responseSaveRoute;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveStateRoute(0);
        break;
    }
  }

  renderSelectRoutesAvailables = () => {
    var localRoutes = this.props.routesReducerState.responseGetRoutes.result || [];
    var routeEmpty = { value: { id: '', name: '', information: '', active: 1 }, label: 'Crear nueva ruta' };
    return (
      <Select
        className='react-select'
        classNamePrefix='react-select'
        id='idViewByRoute'
        name='viewByRoute'
        placeholder='Seleccione la ruta que desea modificar'
        defaultValue={routeEmpty}
        options={
          [routeEmpty].concat(localRoutes.map((itemRoute, indexRoute) => {
            return (
              { value: itemRoute, label: itemRoute.name }
            )
          }
          ))
        }
        onChange={(value) => {
          this.props.setDataRouteForEdit(value.value);
        }
        }
      />
    );
  }
  /**
   * Pinta los contenidos basados en los estados
   */
  render() {
    let {
      nameState,
      informationState,
    } = this.state;

    return (
      <div className='content'>
        {this.state.alert}
        <Card>
          <CardHeader>
            <CardTitle tag='h5'>Datos de la Ruta</CardTitle>
          </CardHeader>
          <CardBody>

            <FormGroup>
              <label>La ruta seleccionada podrá ser modificada</label>
              {this.renderSelectRoutesAvailables()}
            </FormGroup>

            <FormGroup className={`has-label ${nameState}`}>
              <label>Nombre *</label>
              <Input
                name='name'
                type='text'
                maxLength='40'
                value={FrameWorkGetDefaulValue(this.state, 'name')}
                onChange={e => FrameWorkChange(this, e.target.value, 'name', 'have-content', '1')}
              />
              {this.state.nameState === 'has-danger' ? (
                <label className='error'>
                  Ingrese el nombre
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${informationState}`}>
              <label>Información</label>
              <Input
                className='textarea'
                name='information'
                type='textarea'
                maxLength='300'
                cols='80'
                rows='4'
                value={FrameWorkGetDefaulValue(this.state, 'information')}
                onChange={e => FrameWorkChange(this, e.target.value, 'information', 'have-content', 1)}
              />
              {this.state.informationState === 'has-danger' ? (
                <label className='error'>
                  Ingrese la información adicional que requiera
                    </label>
              ) : null}
            </FormGroup>

            <FormGroup check className='mt-2'>
              <Label check className='has-danger'>
                <Input
                  name='active'
                  type='checkbox'
                  checked={this.state.active === 1}
                  onChange={value => {
                    this.setState({ active: this.state.active === 1 ? 0 : 1 });
                  }}
                />
                <span className='form-check-sign' />
                {FrameWorkPutTextToActiveInactiveUser(this.state.active, 1)}
              </Label>
            </FormGroup>

            <div className='category form-category'>
              * Campos obligatorios
              </div>

          </CardBody>

          <CardFooter className='text-right'>
            <Button color={FrameWorkGetSecundaryColorButton()} className='btn-round mb-0' onClick={() => {
              try {
                this.props.history.goBack();
              } catch (_) { }
            }}>
              <i className='icon-big nc-icon nc-box text-white' />
              Regresar
                </Button>
            <Button className='btn-round mt-1 mb-0 ml-4' color={FrameWorkGetPrimaryColorButton()} onClick={this.verifyData}>
              <i className='icon-big fa fa-save text-white' />
              Grabar&nbsp;&nbsp;&nbsp;&nbsp;
                </Button>
          </CardFooter>
        </Card>
      </div>
    );
  }
}
/**
 * Gracias a este método se tiene acceso al repositorio de estados único,
 * para este caso se usa el del producto
 * @param {*} state 
 */
const mapStateToProps = state => {
  return {
    routesReducerState: state.routesReducerState
  };
};

/**
 * Gracias a este método se pueden cambiar los estados globales
 * también permite acceder a las solicitudes del Epic para su
 * procesamiento en el backend
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
  return {

    setMessageSaveStateRoute: (messageSaveStateRoute) => dispatch(setMessageSaveStateRoute(messageSaveStateRoute)),
    setDataRouteForEdit: (dataRouteForEdit) => dispatch(setDataRouteForEdit(dataRouteForEdit)),

    requestSaveRoute: (dataRoute) => bindActionCreators(dispatch(requestSaveRoute(dataRoute)), dispatch),

  };
};

/**
 * Responde con el componente general del Usuario en su parte del formulario de datos
 */
export default connect(mapStateToProps, mapDispatchToProps)(RoutesForm);